<!-- Teileauswahl: Stellt die gesamte Teileauswahl dar (Auch: 'Erste Konfiseite') standardPartial.jsp-->
<template>
    <div id="TeileauswahlOverview" class="container">
        <b-button class="segmentbutton" block variant="light" :disabled="true">
            <h4 class="float-left">
                <span ref="teileauswahlBadge" :class="badgeClass">1</span>
                {{ $t('teileauswahl-overview.heading') }}</h4>
            <!-- Reset Button -->
            <b-button class="float-right graybutton" v-on:click="onClickReset">
                {{ $t('teileauswahl-overview.reset') }}
                <b-spinner v-if="!validData" small />
            </b-button>
        </b-button>
        <b-collapse id="collapseTeileauswahl" accordion="confiAccordion" role="tabpanel" :visible="collapseVisible"
                    v-on:hidden="changeCollapseState(false)" v-on:shown="changeCollapseState(true)">
            <b-container>
                <b-row>
                    <b-col lg="6" style="padding: 0px">
                        <size-input :part-sizes="partSizes" :maxStklId="maxStklId"/>
                    </b-col>
                    <b-col lg="6" style="padding: 0px">
                        <type-input :typen-schluessel="typenSchluessel"/>
                    </b-col>
                </b-row>
            </b-container>
            <b-card-group columns v-bind:class="{'card-columns-no3D':(!kunde && !anonym)}">
                <Merkmal v-for="merkmal in merkmale" :key="merkmal.name"
                         :merkmal="merkmal" v-on:selection-changed="onSelectionChanged"/>
                <OptionaleGruppe v-for="optionaleMerkmale in optionaleGruppen"
                                 :key="optionaleMerkmale.name"
                                 :optionale-merkmale="optionaleMerkmale"
                                 v-on:selection-changed="onSelectionChanged"/>
            </b-card-group>
            <!-- Continue Button -->
            <div class="float-right" style="padding: 0px 0px 10px 0px">
                <b-button :disabled="!isReady" v-bind:class="{ 'mayr-button-blue': isReady, 'mayr-button-inactive': !isReady }" href="#"
                          v-b-toggle.collapseTeileauswahl.collapsePorduktmerkmale @click="trackTeileAuswahlAbgeschlossen()">
                    <span>{{ $t('general.continue') }}</span>
                </b-button>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    import Merkmal from './Merkmal'
    import OptionaleGruppe from "./OptionaleGruppe";
    import isEmpty from "@/mixins/isempty";

    import {bus} from '../../../main';
    import SizeInput from "@/components/config-page/utils/SizeInput";
    import TypeInput from "@/components/config-page/utils/TypeInput";
    import matomoTracking from "@/mixins/matomoTracking";


    export default {
        name: 'TeileauswahlOverview',
        props: ['merkmale', 'optionaleGruppen', 'hinweistexte', 'partSizes', 'maxStklId', 'typenSchluessel'],
        components: {
            TypeInput,
            SizeInput,
            Merkmal,
            OptionaleGruppe
        },
        mixins: [isEmpty, matomoTracking],
        data: function () {
            return {
                collapseVisible: true,
                validData: true
            }
        },
        created() {
            bus.$on('produktmerkmale-collapsed', () => {
                this.toggleState();
            })
        },
        watch: {
            merkmale: {
                handler() {
                    this.validData = true
                }
            }
        },
        computed: {
            isReady: function () {
                if (this.isEmpty(this.$props.merkmale))
                    return true;

                return this.$props.merkmale.every(merkmal => (!this.isEmpty(merkmal.selected)));
            },
            badgeClass: function () {
                if (this.isReady) {
                    return 'badge badge-primary';
                }
                return 'badge badge-secondary';
            },
            buttonVariant: function () {
                if (this.isReady) {
                    return "primary";
                } else {
                    return "secondary";
                }
            },
            anonym: function() {
                return this.$store.getters.getUserData.anonym;
            },
            kunde: function() {
                return this.$store.getters.getUserData.kunde;
            }
        },
        methods: {
            trackTeileAuswahlAbgeschlossen(){
              this.trackEvent('Konfigurator', 'Teileauswahl abgeschlossen')
            },
            onSelectionChanged() {
                bus.$emit('teileauswahl-changed', this.isNotReady);
                this.$emit('selection-changed');
            },
            changeCollapseState(visible) {
                this.collapseVisible = visible;
            },
            onClickReset() {
                this.validData = false;
                this.$store.dispatch('resetKonfigModel');
                if (!this.collapseVisible) {
                    this.$root.$emit('bv::toggle::collapse', 'collapseTeileauswahl')
                }
            }
        }
    }
</script>

<style scoped>




    .badge {
        padding: 0.15em 0.4em;
        top: -3px;
        font-weight: 600;
    }


    .mayrbuttoninactive {
        border-radius: 0px;
        background-color: #bfbfbf;
        border:none;
        color: #000
    }

</style>
